import styled from "styled-components";
import {Select} from "antd";

export const SelectField = styled(Select)`
    width: auto;
    max-width: 100%;
    .ant-select-selector {
        border-radius: 8px !important;
        display: flex !important;
        align-items: center !important;
        gap: 8px !important;
        padding: 12px 16px !important;
        border: none !important;
        background-color: #aef001 !important;
        color: #000 !important;
        font-size: 14px !important;
        font-weight: 600 !important;
        cursor: pointer !important;
        transition: all 0.3s ease !important;
        white-space: nowrap !important;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1) !important;
        min-height: 48px !important;
        width: auto !important;
    }

    .ant-select-selector:hover {
        background-color: #aef001 !important;
        transform: translateY(-2px) !important;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15) !important;
    }

    .ant-select-arrow {
        color: #000 !important;
    }

    .ant-select-selection-item {
        font-size: 14px !important;
        font-weight: 600 !important;
        color: #000 !important;
    }

    &.ant-select-focused .ant-select-selector {
        border-color: #aef001 !important;
        box-shadow: 0 0 0 2px rgba(174, 240, 1, 0.2) !important;
    }

    @media (max-width: 768px) {
        min-width: 150px;
        .ant-select-selector {
            min-width: 150px !important;
        }
    }
`;
